export class UnitType {
    id:number = 0;
    name:string = '';
    min_id:number = 0;
    max_id:number = 0;
}
